var UISubscribeMsg = require("clover/ui/UISubscribeMessage")
const NewIntroManager = require("./NewIntroManager")
const IconSize = 72
const MaxScale = 1.4
let NewIntroNode = xClass("NewIntroNode", cc.Node)
NewIntroNode.prototype.ctor = function() {
    cc.Node.prototype.ctor.call(this);  

    let deltaPosY = 0
    if (META.platform === XcloverPlatform.wechatgame) {
        deltaPosY = -4
    }

    this.lbTip = cc.Label.create("",  (window.qq && cc.sys.os === cc.sys.OS_ANDROID)? FONT_DEF.microsoftYahei_30_whiteStroke: FONT_DEF.microsoftYahei_30_blueBlueStroke);
    this.lbTip.setScale(0.9);
    this.lbTip.setAnchorPoint(0, 0.5);
    this.addChild(this.lbTip);

    this.lbIsland = cc.Label.create("", (window.qq && cc.sys.os === cc.sys.OS_ANDROID)? FONT_DEF.microsoftYahei_30_whiteStroke: FONT_DEF.microsoftYahei_30_yellowBrownStroke);
    this.lbIsland.setScale(0.9);
    this.lbIsland.setAnchorPoint(0, 0.5);
    this.lbIsland.setPositionY(deltaPosY);
    this.addChild(this.lbIsland);

    this.icon = null;
    this.iconRes = null;
    
    this.lastConfig = null;

    this.isBusy = false;
}

NewIntroNode.prototype.update = function() {
    if (this.isBusy)
        return;

    this.isBusy = true;
    NewIntroManager.getInstance().load()
        .then(()=> {
            this.isBusy = false;
            if (this.isRunning())
                this.innerUp();
        })
        .catch((err)=> {
            this.isBusy = false;
            console.warn("NewIntroNode.update failed.", err);
        });
}

NewIntroNode.prototype.innerUp = function() {
    let levelId = UserManager.getInstance().user.topLevelId;
    let maxLevel = MetaManager.getMaxNormalLevelByLevelArea();
    let config = NewIntroManager.getInstance().getNewIntro(levelId, maxLevel);
    
    if (config == null) {
        this.setVisible(false);
        this.removeIcon();
        return;
    }

    if (config === this.lastConfig)
        return;

    console.log("@@@@lvl compare:", levelId, "&&", maxLevel)
    if (window.mini && mini.supportSubscribeMessage() && levelId >= maxLevel){
        var f = this.initSubscribeMessage();
        if (f == false){
            // 用玩吧数据玩QQ的其实不能订阅
        }else{
            this.lbTip.setVisible(false)
            this.removeIcon();
            return;
        }
    }
    this.lastConfig = config;

    let width = 0;
    this.lbTip.setString(config.desc);
    width += this.lbTip.getContentSize().width * this.lbTip.getScaleX();

    if (config.type == NewIntroManager.ContentType.kIsland) {
        this.lbIsland.setString(config.name);
        this.lbIsland.setVisible(true);
        width += this.lbIsland.getContentSize().width * this.lbIsland.getScaleX();
    } else {
        this.lbIsland.setVisible(false);
    }
    
    if (config.res == null) {
        this.removeIcon();
    } else if (config.res != this.iconRes) {
        this.removeIcon();
        this.showIcon(config.res);
    }
    if (this.icon != null) {        
        width += IconSize;
    }
    let startX = -width / 2;
    this.lbTip.setPosition(startX, 0);
    startX += this.lbTip.getContentSize().width * this.lbTip.getScaleX();
    if (this.lbIsland != null && this.lbIsland.isVisible()) {
        this.lbIsland.setPosition(startX, 0);
        startX += this.lbIsland.getContentSize().width * this.lbIsland.getScaleX();
    }
    if (this.icon != null && this.icon.isVisible()) 
        this.icon.setPosition(startX, 0);
    this.setVisible(true);
}

NewIntroNode.prototype.removeIcon = function() {
    if (this.icon != null) {
        this.icon.removeEventListener("load", this.updateIconSize, this);
        this.icon.removeFromParent(true);
        this.icon = null;
        ResManager.release([this.iconRes]);
        this.iconRes = null;
    }
}

NewIntroNode.prototype.showIcon = function(resPath) {
    if (this.icon == null) {
        let icon = cc.Sprite.create();
        icon.setAnchorPoint(0, 0.5);
        this.addChild(icon);
        this.icon = icon;
        this.icon.addEventListener("load", this.updateIconSize, this);
    }
    this.iconRes = resPath;    

    let preloaded = false
    if (cc.sys.os === cc.sys.OS_ANDROID){
        if (window.mini && (mini.getPlatform() == MiniPlatform.qqlightGame || checkSupportETC())){
            preloaded = true
            ResManager.load(resPath)
            .then(()=>{
                if (this.iconRes = resPath && this.icon != null) {
                    this.icon.initWithFile(resPath);
                }
            })
            .catch(()=>{})
        }
    }
    if (!preloaded)
        this.icon.initWithFile(resPath);

    if(window.qq && cc.sys.os === cc.sys.OS_ANDROID) {
        ResManager.load(resPath)
        .then(()=>{
            if (this.iconRes = resPath && this.icon != null) {
                this.icon.initWithFile(resPath);
            }
        })
        .catch(()=>{})
    } else 
        this.icon.initWithFile(resPath);
} 

NewIntroNode.prototype.updateIconSize = function() {
    if (this.icon != null) {
        this.icon.setScale(Math.min(IconSize / this.icon.getContentSize().width, MaxScale));
    }
}

NewIntroNode.prototype.onCleanup = function() {
    this.removeIcon();

    this.lbTip = null;
    this.lbIsland = null;
    this.lastConfig = null;
}

NewIntroNode.prototype.updateSubmsgLvl = function(subAccepted){
    if (subAccepted){
        cc.UserDefault.getInstance().setStringForKey("lvl_submsg", MetaManager.getMaxNormalLevelByLevelArea())
    }
}
NewIntroNode.prototype.trySubscribeMsg = function(){
    var self = this

    if (self.subMsg){
        let userInstance = cc.UserDefault.getInstance()
        
        let lastSubMsgLvl = userInstance.getStringForKey("lvl_submsg")
        let curLvl = MetaManager.getMaxNormalLevelByLevelArea()
        let sendMsg = false
        if (lastSubMsgLvl != curLvl){
            sendMsg = true
        }
        console.log("@@@@submsg lvl:", curLvl, " lastLvl:",lastSubMsgLvl, " sendMsg", sendMsg)
        self.subMsg.trySubscribeMsg(sendMsg, handler(self, self.updateSubmsgLvl))
    }
    
}
NewIntroNode.prototype.initSubscribeMessage =function(){
    var self = this
    if (self.subMsg != null)
        return;

    var subKey = "";
    if (window.mini && mini.getPlatform() == MiniPlatform.wechatGame) {
        subKey = "BCDiHiXxf6ZRttDNmUh36X8WsX6CfCDDJ023KocBMgo";
    }else if (window.mini && mini.getPlatform() == MiniPlatform.qqlightGame) {
        subKey = "65a2c6a846a2bdc56adf48935098e638";
    }

    var moduleId = UISubscribeMsg.getModuleId(subKey)
    let subCfg = MetaManager.getInstance().getSubscribeCfg()
    console.log("@@@@get sub cfg:", subCfg, " moduleId:", moduleId)
    if (!subCfg[moduleId] || subCfg[moduleId] <= 0)
        return false;

    console.log("@@@@run init sub")
    if (window.mini && mini.supportSubscribeMessage() && !MysteryIslandManager.getInstance().isOpen(true)){
        UISubscribeMessage.preload().then(
            ()=>{
                console.log("@@@@success")
                self.subMsg = UISubscribeMsg.create(
                    subKey, 
                    getText("subscription_level_text"),
                    cc.c3b(236,255,255),
                    false,
                    true,
                    false,
                    false,
                    getText("subscription_level_success"),
                    getText("subscription_level_fail"),
                    30
                    )
                let width = (self.getContentSize().width - self.subMsg.getWidth())*0.5;
                self.subMsg.setPosition(width, 0)
                self.addChild(self.subMsg)
                self.subMsg.on("submsg_select", ()=>{self.trySubscribeMsg()})
            }).catch(()=>{console.log("@@@@error")})
    }
}

module.exports = NewIntroNode